import { useContext } from 'react';
import { TabsContext } from './context';

export const useTabsContext = () => {
    const context = useContext(TabsContext);

    if(!context) {
        throw Error('useTabsContext must be used inside an AuthContextProvider')
    }
    
    return context
};